var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "selectimage-a",
    d: "M32,0 C14.326888,0 0,14.326888 0,32 C0,49.673112 14.326888,64 32,64 C49.673112,64 64,49.673112 64,32 C64,14.326888 49.673112,0 32,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "selectimage-b",
    width: "106.2%",
    height: "106.2%",
    x: "-3.1%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "selectimage-c",
    d: "M33.3333333,31.1049107 L33.3333333,32.2154018 C33.3333333,34.0553467 31.8409722,35.546875 30,35.546875 L3.33333333,35.546875 C1.49236111,35.546875 0,34.0553467 0,32.2154018 L0,14.4475446 C0,12.6075997 1.49236111,11.1160714 3.33333333,11.1160714 L4.44444444,11.1160714 L4.44444444,14.4475446 L3.75,14.4475446 C3.51988135,14.4475446 3.33333333,14.6339886 3.33333333,14.8639788 L3.33333333,31.7989676 C3.33333333,32.0289579 3.51988135,32.2154018 3.75,32.2154018 L29.5833333,32.2154018 C29.813452,32.2154018 30,32.0289579 30,31.7989676 L30,31.1049107 L33.3333333,31.1049107 Z M36.25,7.78459821 L10.4166667,7.78459821 C10.186548,7.78459821 10,7.97104213 10,8.20103237 L10,25.1360212 C10,25.3660114 10.186548,25.5524554 10.4166667,25.5524554 L36.25,25.5524554 C36.4801186,25.5524554 36.6666667,25.3660114 36.6666667,25.1360212 L36.6666667,8.20103237 C36.6666667,7.97104213 36.4801186,7.78459821 36.25,7.78459821 Z M36.6666667,4.453125 C38.5076389,4.453125 40,5.94465332 40,7.78459821 L40,25.5524554 C40,27.3924003 38.5076389,28.8839286 36.6666667,28.8839286 L10,28.8839286 C8.15902778,28.8839286 6.66666667,27.3924003 6.66666667,25.5524554 L6.66666667,7.78459821 C6.66666667,5.94465332 8.15902778,4.453125 10,4.453125 L36.6666667,4.453125 Z M18.3333333,12.2265625 C18.3333333,13.7598036 17.0896528,15.0027902 15.5555556,15.0027902 C14.0214583,15.0027902 12.7777778,13.7598036 12.7777778,12.2265625 C12.7777778,10.6933214 14.0214583,9.45033482 15.5555556,9.45033482 C17.0896528,9.45033482 18.3333333,10.6933214 18.3333333,12.2265625 Z M13.3333333,18.8895089 L16.0774306,16.146943 C16.4028472,15.8217079 16.9304861,15.8217079 17.2559722,16.146943 L20,18.8895089 L27.1885417,11.7049787 C27.5139583,11.3797437 28.0415972,11.3797437 28.3670833,11.7049787 L33.3333333,16.6685268 L33.3333333,22.2209821 L13.3333333,22.2209821 L13.3333333,18.8895089 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    xlinkHref: "#selectimage-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#selectimage-b)",
    xlinkHref: "#selectimage-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(12 12)",
    xlinkHref: "#selectimage-c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraUpload);
export default __webpack_public_path__ + "static/media/camera_upload.2914eb4abd41b776b907314514e9b41f.svg";
export { ForwardRef as ReactComponent };